<template>
  <div id="app">
    <b-container>
      <b-card title="Rainy Cafe" img-src="./assets/rainy.jpg" overlay text-variant="white"></b-card>
      <MediaPlayer v-bind:sources="rain" title="Rain"/>
      <MediaPlayer v-bind:sources="cafe" title="Cafe"/>
      <HelloWorld v-on:new-quote="onQuote()" v-bind:msg="quote"/>
    </b-container>
  </div>
  <!-- Rain recording by Matt Barnard  / https://soundcloud.com/mattt -->
  <!-- Cafe recording by Samuel Justice / https://soundcloud.com/samueljustice -->
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import MediaPlayer from "./components/MediaPlayer.vue";

export default {
  name: "app",
  components: {
    HelloWorld,
    MediaPlayer
  },
  data: function() {
    return {
      rain: [{ url: "assets/rain.mp3", type: "audio/mpeg" }],
      cafe: [{ url: "assets/cafe.mp3", type: "audio/mpeg" }],
      quotes: [
        "She stole my heart and my cat.",
        "Coffee fixes everything.",
        "The rain in Spain stays mainly on the plain.",
        "“Just coffee. Black—like my soul.”",
        "“Black as the devil, hot as hell, pure as an angel, sweet as love.”",
        "HOT BEAN WATER",
        "But wait - there's more"
      ],
      quote: ""
    };
  },
  mounted: function() {
    this.quote = this.quotes[Math.floor(Math.random() * this.quotes.length)];
  },
  methods: {
    onQuote: function() {
      let previous = this.quote;
      while (previous === this.quote) {
        this.quote = this.quotes[
          Math.floor(Math.random() * this.quotes.length)
        ];
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
